// Gusto39 Kopf und Fuß: Menü-Schublade, Unterkategorien, Aufklapplisten (Land, Sprache, Suche mobil).
// Ohne JavaScript bleibt alles bedienbar: Aufklapplisten sind <details>, Land und Sprache normale Formulare.
(() => {
  const drawer = document.getElementById('MenuDrawer');
  const opener = document.querySelector('[data-drawer-open]');

  if (drawer && opener) {
    const close = () => drawer.close();
    opener.addEventListener('click', () => {
      drawer.showModal();
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('is-locked');
    });
    drawer.addEventListener('close', () => {
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('is-locked');
      opener.focus();
    });
    drawer.querySelector('[data-drawer-close]')?.addEventListener('click', close);
    // Klick auf den abgedunkelten Hintergrund schließt die Schublade.
    drawer.addEventListener('click', (event) => { if (event.target === drawer) close(); });
    // Ab Desktop gibt es keine Schublade mehr.
    matchMedia('(min-width: 1024px)').addEventListener('change', (event) => { if (event.matches && drawer.open) close(); });
  }

  // Unterkategorien: Desktop per Maus oder Pfeil-Knopf (Klick, Tastatur, Esc), Schublade per Pfeil-Knopf.
  const desktop = matchMedia('(min-width: 1024px)');
  const subnavs = [...document.querySelectorAll('[data-subnav]')];
  const setSub = (item, open) => {
    const button = item.querySelector('button[aria-controls]');
    const list = document.getElementById(button.getAttribute('aria-controls'));
    button.setAttribute('aria-expanded', String(open));
    item.classList.toggle('is-open', open);
    if (list.classList.contains('drawer__sub')) list.hidden = !open;
  };
  subnavs.forEach((item) => {
    const inDrawer = !!item.closest('.drawer');
    item.querySelector('button[aria-controls]').addEventListener('click', () => {
      // Hat die Maus das Menü gerade geöffnet, bleibt es beim ersten Klick offen.
      const open = item.dataset.hover === '1' || !item.classList.contains('is-open');
      delete item.dataset.hover;
      if (!inDrawer) subnavs.forEach((other) => { if (other !== item && !other.closest('.drawer')) setSub(other, false); });
      setSub(item, open);
    });
    if (inDrawer) return;
    let timer;
    item.addEventListener('mouseenter', () => {
      if (!desktop.matches) return;
      clearTimeout(timer);
      if (!item.classList.contains('is-open')) item.dataset.hover = '1';
      setSub(item, true);
    });
    item.addEventListener('mouseleave', () => { delete item.dataset.hover; timer = setTimeout(() => setSub(item, false), 150); });
    item.addEventListener('focusout', (event) => { if (!item.contains(event.relatedTarget)) setSub(item, false); });
    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
      event.stopPropagation();
      setSub(item, false);
      item.querySelector('button[aria-controls]').focus();
    });
  });

  const dropdowns = [...document.querySelectorAll('details[data-dropdown]')];
  dropdowns.forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      dropdowns.forEach((other) => { if (other !== details) other.open = false; });
      if (details.hasAttribute('data-search')) details.querySelector('input[type="search"]')?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    dropdowns.forEach((details) => { if (details.open && !details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = dropdowns.find((details) => details.open);
    if (!open) return;
    open.open = false;
    open.querySelector('summary')?.focus();
  });
})();
